// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.4142 1L21 6.58579V23H3V1H15.4142ZM14.5 7.5H19L14.5 3V7.5ZM13 10H9L9 18H11V12H13V18H15L15 12C15 10.8954 14.1046 10 13 10Z"}}]};

const FileOnenoteFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-onenote-filled',
    ref,
    icon: element,
  },
));

FileOnenoteFilledIcon.displayName = 'FileOnenoteFilledIcon';

export default FileOnenoteFilledIcon;
